import { RENDER_ORDER } from "@graphic/constants";
import { SpaceObjectInstance } from "@graphic/types";
import { useFrame, useThree } from "@react-three/fiber";
import { useRef, useEffect } from "react";

import { Vector3 } from "three";
import { CSS2DObject } from "three/examples/jsm/renderers/CSS2DRenderer";

type useLabelControlProps = {
  data: SpaceObjectInstance;
  getPosition: () => Vector3;
};

export const useLabelControl = (props: useLabelControlProps) => {
  const labelRef = useRef<CSS2DObject>(null);
  const get = useThree(state => state.get);

  useEffect(() => {
    if (!props.data || !labelRef.current) return;

    const scene = get().scene;

    const { x, y, z } = props.getPosition();
    labelRef.current.position.set(x, y, z);

    scene.add(labelRef.current);

    return () => {
      if (labelRef.current) {
        scene.remove(labelRef.current);
      }
    };
  }, [props, labelRef]);

  useFrame(() => {
    if (!props.data || !labelRef.current) return;
    if (!labelRef.current.visible) return;

    updateLabelPosition();
  }, RENDER_ORDER.LABEL);

  const updateLabelPosition = () => {
    const { x, y, z } = props.getPosition();

    labelRef.current.position.set(x, y, z);
  };

  return {
    labelRef
  };
};
